import { useContext } from 'react'
import { useApp } from '../hooks/useApp'
import type { IAvailableApps } from '../utils/availableApps'
import { carkulkaExtraOffersContext } from './CarkulkaExtraOffersProvider'
import { carkulkaOffersContext } from './CarkulkaOffersProvider'
import { cestovkoOffersContext } from './CestovkoOffersProvider'
import type { IOffersContext } from './OffersProvider'
import { propertyOffersContext } from './PropertyOffersProvider'

const getContext = (app: IAvailableApps['appId'] | null) => {
  switch (app) {
    case 'cestovko': return cestovkoOffersContext
    case 'chaloupka': return propertyOffersContext
    case 'carkulka': return carkulkaOffersContext
    case 'carkulka-extra': return carkulkaExtraOffersContext
    default: throw new Error('unknow app')
  }
}

export const useGetOffersContext = () => {
  const { app } = useApp()
  const ctx: React.Context<IOffersContext<any>> = getContext(app)

  return useContext(ctx)
}
